<template>
  <v-image
    ref="canvasImage"
    :config="configImg"
    :width="imageDimensions.width"
    :height="imageDimensions.height"
  />
</template>

<script setup>
import {
  computed,
} from "vue";
// import useProjection from '@/composables/annotationTool/useProjection.js';

// const {
//   drawPCDPoints,
// } = useProjection();

const props = defineProps({
  // lidarPoints: {
  //   // three.js Points with buffer geometry
  //   type: Object,
  //   default: null,
  // },
  lidarProjection: {
    // three.js Points with buffer geometry
    type: HTMLImageElement,
    default: null,
  },
  imageDimensions: {
    type: Object,
    default: null,
  },
  cameraIntrinsic: {
    type: Array,
    default: null,
  },
});

const configImg = computed(() => ({
  fill: 'transparent',
  x: 0,
  y: 0,
  image: props.lidarProjection,
  width: props.imageDimensions.width,
  height: props.imageDimensions.height,
  draggable: false,
}));

// const canvasImageSrc = ref(null);

// onMounted(async () => {
//   const projectionImage = await drawPCDPoints(props.lidarPoints, props.imageDimensions.width, props.imageDimensions.height);
//   canvasImageSrc.value = projectionImage;
// });
// watch(() => props.lidarPoints, async () => {
//   const projectionImage = await drawPCDPoints(props.lidarPoints, props.imageDimensions.width, props.imageDimensions.height);
//   canvasImageSrc.value = projectionImage;
// }, { deep: true });
</script>
